<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  computed: {
    optionsMerged: function() {
      const defaultOptions = {
        noDataLabel: this.$t('charts.no_data'),
        datasetFill: false,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          intersect: false
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: false,
                labelString: 'Month'
              },
              ticks: {
                fontColor: '#fff'
              },
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: false,
                labelString: 'Value'
              },
              ticks: {
                fontColor: '#fff'
              },
              gridLines: {
                color: '#FFFFFF',
                zeroLineColor: '#fff'
              }
            }
          ]
        }
      }
      return { ...defaultOptions, ...this.options }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.optionsMerged)
  }
}
</script>

<style lang="scss" scoped>
canvas {
  height: 162px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/charts/LineChart.vue